import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useMemo, useState } from 'react';
import { Select } from 'tdesign-react';
import { isVoid } from '@/utils/common';
import { getClusterResources } from '@/services/permissionsService';

export default function TopicsInput({ clusterName, value, onChange, ...others }) {
  const [options, setOptions] = useState([]);

  const _value = useMemo(() => {
    if (isVoid(value)) {
      return [];
    }
    if (typeof value === 'string') {
      return value.split(',');
    }
  }, [value]);

  const loadOptions = useMemoizedFn(async () => {
    const { data = [] } = await getClusterResources({
      clusterName,
      type: 'topic',
    });
    setOptions(
      data.map((item) => ({
        label: item,
        value: item,
      })),
    );
  }, []);

  useEffect(() => {
    loadOptions();
  }, [loadOptions, clusterName]);

  const selectChange = (value) => {
    if (value instanceof Array) {
      onChange(value.join(','));
    } else {
      onChange(value);
    }
  };

  return (
    <Select
      options={options}
      value={_value}
      onChange={selectChange}
      clearable
      filterable
      multiple
      {...others}
    />
  );
}
